import { observer } from '@formily/reactive-vue';
import { h, useField, connect, mapProps, mapReadPretty } from '@formily/vue';
import MoveTabNavigation from './MoveTabNavigation.vue';
import { defineComponent, ref, watch } from 'vue-demi';
import { PreviewText } from '@formily/element';
// import { Dialog } from "vant";



const formilyMoveTabNavigation = observer(
  defineComponent({
    name: 'MoveTabNavigation',
    props: ['value', 'options', 'collapse',],
    setup(curProps, { attrs, emit }) {
      // console.log('curProps==>', curProps, attrs);
      // 通过以下三部获取到组件设计器里的参数
      const field = useField();
      const val = useField().value;
      const data = field.value.componentProps;
      return () =>
        h(
          MoveTabNavigation,
          {
            attrs: {
              ...curProps,
              ...attrs,
              value: curProps.value,
              // : curProps?.value == 0 ? 0 : curProps.value,
              // options: [{"title": "Test111", "description": "步骤1","disable":true},{"title": "Test111", "description": "步骤1","disable":true},{"title": "Test111", "description": "步骤1","disable":true}],
              options: data.options,
              move: data.move,
              collapse: data.collapse,
              background: data.background == undefined ? '666' : data.background,
              activeFontColor: data.activeFontColor == undefined ? '07c160' : data.activeFontColor,
              inactiveFontColor: data.inactiveFontColor == undefined ? 'E5EBE7' : data.inactiveFontColor,
              finishFontColor: data.finishFontColor == undefined ? 'fff' : data.finishFontColor,
              arrowColor: data.arrowColor == undefined ? 'fff' : data.arrowColor,
              collapsedScale: data.collapsedScale == undefined ? Number(0.5) : Number(data.collapsedScale),
            },
            on: {
              change: (index) => {
                emit('change', index);

              }

            },
          },
          {
            default: () => [curProps.value || attrs.content],
          }
        );
    },
  })
);

export default formilyMoveTabNavigation;

